
import { Modal } from 'antd';
import React, { useState } from "react";
import activeSVG from "../assets/svgs/ActiveCampaign_Logo.svg";
import dripSVG from "../assets/svgs/Drip_Logo__black.svg";
import hubpsotSVG from "../assets/svgs/hubSpot_Logo__black.svg";
import keapSVG from "../assets/svgs/keap.svg";
import undeciedSVG from '../assets/svgs/undecided.svg';
/**
 * @param value initialValue passed by parent Form.Item.
 * @param onChange a callback for Form.Item to read its child component's value.
 * @constructor
 */
const SelectPlatformPartial = ({ value, onChange }) => {
  const queryParams = new URLSearchParams(window.location.search);
  const mainPlatform = queryParams.get("platform") || "yeti";
  const [platform, setPlatform] = useState(value || "");
  const [isModalVisible, setIsModalVisible] = useState(false);

  const change = (platformValue) => {
    if (platformValue === platform) {
      setPlatform("");
      onChange("");
      return;
    }

    if (platformValue === "undecided") {
      setIsModalVisible(true);
      return;
    }

    setPlatform(platformValue);

    if (typeof onChange === "function") {
      onChange(platformValue);
    }
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      {mainPlatform === 'yeti' &&
        <div className="registration-select-card-wrapper">
          <div
            href="#"
            className="registrationCard drip cursor-pointer"
            onClick={() => {
              change("Drip");
            }}
          >
            <div className={platform === "Drip" ? "active" : "overlay"} />
            <div className="circle">
              <img src={dripSVG} alt="" />
            </div>
            <p />
          </div>
          <div
            href="#"
            className="registrationCard hubspot cursor-pointer"
            onClick={() => {
              change("Hubspot");
            }}
          >
            <div className={platform === "Hubspot" ? "active" : "overlay"} />
            <div className="circle">
              <img src={hubpsotSVG} alt="" />
            </div>
            <p />
          </div>
          <div
            href="#"
            className="registrationCard activeCampaign cursor-pointer"
            onClick={() => {
              change("ActiveCampaign");
            }}
          >
            <div
              className={platform === "ActiveCampaign" ? "active" : "overlay"}
            />
            <div className="circle">
              <img style={{ width: "150px" }} src={activeSVG} alt="" />
            </div>
            <p />
          </div>

        </div>
      }
      {mainPlatform === 'fixyourfunnel' &&
        <div className="registration-select-card-wrapper">
          <div
            href="#"
            className="registrationCard keap"
            onClick={() => {
              change("keap");
            }}
          >
            <div className={platform === "keap" ? "active" : "overlay"} />
            <div className="circle">
              <img src={keapSVG} alt="" />
            </div>
            <p />
          </div>
          <div
            href="#"
            className="registrationCard undecided"
            onClick={() => {
              change("undecided");
            }}
          >
            <div
              className={platform === "undecided" ? "active" : "overlay"}
            />
            <div className="circle">
              <img style={{ width: "150px" }} src={undeciedSVG} alt="" />
            </div>
            <p />
          </div>
          <Modal title="Platform Selection" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
            <p>FixYourFunnel is deeply integrated with Keap. You can also check out our other service YetiText.</p>
          </Modal>
        </div>
      }
    </>
  );
};

export default SelectPlatformPartial;
